import { defineComponent as m, h as o } from "vue";
import { rawIcons as a } from "./raw-icons.js";
import { extractRootHtmlElement as s } from "@scalar-org/vue-render";
const l = m({
  props: ["src", "title", "mask"],
  setup(t) {
    const e = a[t.src];
    if (e) {
      const r = s(e);
      return () => o(r.tagName, r.properties);
    }
    return () => o("img", {
      src: t.src,
      alt: t.title,
      style: "object-fit: contain;",
      class: { "mask-image": t.mask }
    });
  }
});
export {
  l as GuideIcon
};
